<template>
  <el-row type="flex" class="app-layout orver-hidden-x padding-left-10 padding-right-10">
    <div class="flex-1 flex flex-column event-card">
      <div class="event-form">
        <el-form ref="form" :model="formQuery" size="mini">
          <el-row :gutter="20" type="flex" class="flex-justify-left flex-wrap">
            <el-form-item label="平台应用" label-width="70px">
              <system-select
                size="mini"
              />
            </el-form-item>
            <el-form-item label="应用版本号" label-width="90px">
              <el-input
                clearable
                v-model="formQuery.version"
                placeholder="请输入应用版本号"
              ></el-input>
            </el-form-item>
            <el-form-item label="操作系统" label-width="70px">
              <div class="flex">
                <Version
                  :os.sync="formQuery.os"
                  @update="searchTableData"
                />
                <el-input
                  class="margin-left-20 flex-1"
                  clearable
                  v-model="formQuery.osVersion"
                  placeholder="请输入操作系统版本号"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              label="设备型号"
              label-width="70px"
            >
              <el-input
                clearable
                v-model="formQuery.deviceModel"
                placeholder="请输入设备型号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="浏览器"
              label-width="70px"
            >
              <div class="flex">
                <el-input
                  clearable
                  v-model="formQuery.browserName"
                  placeholder="请输入浏览器名称"
                ></el-input>
                <el-input
                  class="margin-left-10"
                  clearable
                  v-model="formQuery.browserVersion"
                  placeholder="请输入浏览器版本"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="用户名" label-width="60px">
              <el-input
                clearable
                v-model="formQuery.userName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户ID" label-width="60px">
              <el-input
                clearable
                v-model="formQuery.userId"
                placeholder="请输入用户ID"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="0">
              <el-button size="mini" type="primary" @click="queryData(1)">搜索</el-button>
              <el-button
                size="mini"
                @click="() => { Object.assign($data, $options.data()); queryData(); }"
              >重置</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="event-table flex-1 flex flex-column margin-top-15">
        <div class="flex-1">
          <el-table
            height="100%"
            :data="tableData"
            size="mini"
            v-loading="queryLoading"
            stripe
          >
            <el-table-column
              v-for="(item, index) in columnsList"
              :width="item.width"
              :min-width="item.minWidth"
              :label="item.label"
              :prop="item.prop"
              :key="index"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template #default="{ row }" v-if="item.tmpl">
                  <template v-if="item.label === '平台应用'">
                    {{ formatSource(row) }}
                  </template>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <el-row class="padding-20">
          <el-col align="right">
            <el-pagination
              class="analyze-users-pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formQuery.pageNum"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :page-size="formQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="formQuery.total"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-row>
</template>
<script>
import { mapGetters } from 'vuex';
import { queryUserList } from '@/api/analyze';
import Version from '../components/version.vue';

export default {
  components: {
    Version,
  },
  data() {
    return {
      queryLoading: false,
      tableData: [],
      columnsList: [
        {
          label: '用户名',
          prop: 'userName',
        },
        {
          label: '用户ID',
          prop: 'userId',
        },
        {
          label: '平台应用',
          tmpl: true,
        },
        {
          label: '应用版本号',
          prop: 'version',
        },
        {
          label: '设备型号',
          prop: 'deviceModel',
        },
        {
          label: '浏览器型号',
          prop: 'browserName',
        },
        {
          label: '浏览器版本',
          prop: 'browserVersion',
        },
        {
          label: '操作系统',
          prop: 'osInfo',
        },
        {
          label: '地域',
          prop: 'city',
        },
        {
          label: '网络环境',
          prop: 'networkType',
        },
      ],
      columns: {
        用户名: true,
        用户ID: true,
        平台应用: true,
        应用版本号: true,
        设备型号: true,
        浏览器型号: true,
        浏览器版本: true,
        操作系统: true,
        地域: true,
        网络环境: true,
      },
      formQuery: {
        browserVersion: '',
        browserName: '',
        range: [],
        pageNum: 1,
        pageSize: 20,
        total: 0,
        deviceModel: '',
        os: '',
        userId: '',
        userName: '',
        version: '',
        osVersion: '',
      },
    };
  },
  mounted() {
    this.queryData();
  },
  watch: {
    source: {
      handler() {
        this.queryData();
      },
    },
    bizChannel: {
      handler(val, old) {
        if (val !== old && this.source === '') {
          this.queryData();
        }
      },
    },
  },
  methods: {
    async queryData() {
      this.searchTableData();
    },
    handleSizeChange(size) {
      this.formQuery.pageSize = size;
      this.formQuery.pageNum = 1;
      this.queryData();
    },
    handleCurrentChange(num) {
      this.formQuery.pageNum = num;
      this.queryData();
    },
    async searchTableData(currentPageNum) {
      if (currentPageNum) {
        this.formQuery.pageNum = currentPageNum;
      }
      try {
        this.queryLoading = true;

        // eslint-disable-next-line object-curly-newline
        const {
          browserName,
          deviceModel,
          browserVersion,
          os,
          userId,
          userName,
          pageNum,
          pageSize,
          version,
          osVersion,
        } = this.formQuery;

        const params = {
          pageNum,
          pageSize,
          os,
          browserName,
          browserVersion,
          deviceModel: deviceModel.replace(/(\().+(\))/g, ''),
          userId,
          userName,
          version,
          osVersion,
        };

        const {
          data: { list, total },
        } = await queryUserList(params);
        this.formQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...list);
      } finally {
        this.queryLoading = false;
      }
    },
    formatSource({ bizChannel, source }) {
      const items = this.bizChannelList.find((item) => item.key === bizChannel);

      if (items) {
        const {
          sources,
          name,
        } = items;

        return `${name} ${sources.find((item) => item.key === source)?.name || '-'}`;
      }
      return '-';
    },
  },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel', 'bizChannelList']),
  },
};
</script>
<style lang="scss" scoped>
.app-layout {
  margin-top: 10px;
  height: calc(100vh - 90px);
  flex-direction: column;
  .flex-table {
    flex: 1;
  }
}
.event-card {
  overflow: hidden;
  background: #fff;
  padding: 20px;
  &::v-deep {
    .el-card__body {
      height: 100%;
      flex-direction: column;
      display: flex;
    }
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
  }
}
.edit-form {
  width: 90%;
  margin: 0 auto;
}
</style>
<style lang="scss">
.disabled {
  .el-upload--picture-card {
    display: none !important;
  }
}
</style>
